@if (!editing) {
  <div class="flex gap-2 items-center">
    {{ dateTimeFaxReceived | date : 'MM/dd/yyyy hh:mm:ss a'}}
    @if (contextService.widgetFeatures.updateDocumentReceivedTime && shouldShowEdit()) {
      <button
        pButton
        text
        rounded
        class="edit-button"
        icon="pi pi-pencil"
        (click)="toggleEditing()"
      ></button>
    }
  </div>
} @else {
   <div class="flex items-center gap-1">
      <p-date-picker
        appendTo="body"
        class="w-full"
        [hourFormat]="12"
        [maxDate]="maxDate"
        [minDate]="minDate"
        [showIcon]="true"
        [showSeconds]="true"
        [showTime]="true"
        [(ngModel)]="dateTimeFaxReceived"
      ></p-date-picker>
        <button text size="small" class="edit-button" icon="pi pi-check" pButton (click)="updateDocumentReceivedTime()"></button>
        <button text size="small" class="edit-button" icon="pi pi-times" pButton (click)="toggleEditing()"></button>
   </div>
}
